import { render, staticRenderFns } from "./registrationForm.vue?vue&type=template&id=80a97e70&scoped=true&"
import script from "./registrationForm.vue?vue&type=script&lang=js&"
export * from "./registrationForm.vue?vue&type=script&lang=js&"
import style0 from "./registrationForm.vue?vue&type=style&index=0&id=80a97e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a97e70",
  null
  
)

export default component.exports